import React, { Component } from "react";
import bsCustomFileInput from "bs-custom-file-input";
import { mensajeExito } from "../../../generico/MensajeSistemaToast"
import DataTable from 'react-data-table-component';
import history from "../../login/history"
import DatosSocio from "../../../generico/DatosSocio"
import { trackPromise } from 'react-promise-tracker';
import AuthService from "../../../../services/login/auth.service";
import ConfigService from "../../../../services/configuracion/ConfigService";
import $ from "jquery";
import Popup from "react-popup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle, faArrowLeft, faArrowRight, faTrashCan, faPlus} from "@fortawesome/free-solid-svg-icons";

export default class AgregarSubsidioPaso3 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.documentCI1 = React.createRef();
    this.documentCI2 = React.createRef();
    this.documentPremio1 = React.createRef();
    this.documentPremio2 = React.createRef();
    this.documentReposoNacimiento = React.createRef();
    this.documentAdopcion = React.createRef();
    this.documentReposo1 = React.createRef();
    this.documentReposo2 = React.createRef();
    this.documentReposo3 = React.createRef();
    this.documentReposo4 = React.createRef();
    this.documentReposo5 = React.createRef();
    this.documentEstudiosLab1 = React.createRef();
    this.documentEstudiosLab2 = React.createRef();
    this.documentEstudiosLab3 = React.createRef();
    this.documentEstudiosLab4 = React.createRef();
    this.documentEstudiosLab5 = React.createRef();
    this.documentReposoInternacion1 = React.createRef();
    this.documentReposoInternacion2 = React.createRef();
    this.documentReposoInternacion3 = React.createRef();
  }

  getInitialState = () => ({
    inputCertificadoMedico: [
      {
        nombre: "",
      },
    ],
    inputCI: [
      {
        nombre: "",
      },
    ],
    inputPremio: [
      {
        nombre: "",
      },
    ],
    inputEstudiosLaboratoriales: [
      {
        nombre: "",
      },
    ],
    inputReposoInternacion: [
      {
        nombre: "",
      },
    ],
    fileCI1: undefined,
    fileCI2: undefined,
    filePremio1: undefined,
    filePremio2: undefined,
    fileReposoNacimiento: undefined,
    fileAdopcion: undefined,
    fileCertificadoMedico1: undefined,
    fileCertificadoMedico2: undefined,
    fileCertificadoMedico3: undefined,
    fileCertificadoMedico4: undefined,
    fileCertificadoMedico5: undefined,
    fileEstudiosLaboratoriales1: undefined,
    fileEstudiosLaboratoriales2: undefined,
    fileEstudiosLaboratoriales3: undefined,
    fileEstudiosLaboratoriales4: undefined,
    fileEstudiosLaboratoriales5: undefined,
    fileReposoInternacion1: undefined,
    fileReposoInternacion2: undefined,
    fileReposoInternacion3: undefined,
    disableSgte: true,
    claseSubsidio: this.props.respuestasData.claseSubsidio,
    cantDiasSubsidio: this.props.respuestasData.cantDiasSubsidio,
  });

  componentDidMount() {
    bsCustomFileInput.init();
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.claseSubsidio !== this.props.respuestasData.claseSubsidio ||
      newProps.reposoDias !== this.props.reposoDias
    ) {
      bsCustomFileInput.init();
    }
  }

  /***********************************
   * POPUP MOSTRAR DATOS SOLICITADOS *
   ***********************************/

  mostrarDatosReposoDomiciliario = () => {
    let mensaje = `
      1. Fecha de expedición.
      2. Nombre y Apellido del Socio.
      3. Datos del médico tratante.
      4. Breve informe clínico o diagnóstico.
      5. Fecha de reposo (desde / hasta).
      6. Firma y sello del médico tratante.`;

    Popup.queue(
      this.notifiPopup("Deberá contener los siguientes datos:", mensaje)
    );
  };

  mostrarDatosInternacion = () => {
    let mensaje = `
        1. Fecha de expedición.
        2. Días y fecha de la internación.
        3. Diagnóstico del médico tratante.
        4. Sello y firma del responsable del Sanatorio 
        u Hospital (director, administrador, jefe de sala 
          o de admisión)
    `;

    Popup.queue(
      this.notifiPopup("Deberá contener los siguientes datos:", mensaje)
    );
  };

  notifiPopup = (titulo, mensaje) =>
    Popup.create({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  /*********************
   * HANDLE VALIDACION *
   *********************/

  handleValidacion = () => {
    //Validacion Premio
    if (this.props.respuestasData.tipoSubsidio === 4) {
      this.validacionPremio();
      return;
    }

    //Validacion Reposo Maternidad Nacimiento/Adopcion
    if (this.props.respuestasData.claseSubsidio === 210) {
      this.validacionReposoMaternidad();
      return;
    }

    //Validacion Reposo Internacion
    if (this.props.respuestasData.claseSubsidio === 8) {
      this.validacionReposoInternacion();
      return;
    }

    // Reposo Domiciliario hasta 6 dias
    if (
      this.props.respuestasData.claseSubsidio === 7 &&
      this.props.respuestasData.cantDiasSubsidio < 7
    ) {
      this.validacionReposoDomiciliarioMenor7();
      return;
    }

    // Reposo Domiciliario mayor a 7 dias
    if (
      this.props.respuestasData.claseSubsidio === 7 &&
      this.props.respuestasData.cantDiasSubsidio > 6
    ) {
      this.validacionReposoDomiciliarioMayor7();
      return;
    }
  };

  validacionPremio() {
    if (this.state.fileCI1 && this.state.filePremio1) {
      this.setState({ disableSgte: false }, () => {});
    } else {
      this.setState({ disableSgte: true }, () => {});
    }
  }

  validacionReposoMaternidad() {
    if (
      this.state.fileCI1 &&
      (this.state.fileReposoNacimiento || this.state.fileAdopcion)
    ) {
      this.setState({ disableSgte: false }, () => {});
    }
  }

  validacionReposoInternacion() {
    if (this.state.fileCI1 && this.state.fileReposoInternacion1) {
      this.setState({ disableSgte: false }, () => {});
    }
  }

  validacionReposoDomiciliarioMenor7() {
    if (this.state.fileCI1 && this.state.fileCertificadoMedico1) {
      this.setState({ disableSgte: false }, () => {});
    }
  }

  validacionReposoDomiciliarioMayor7() {
    if (
      this.state.fileCI1 &&
      this.state.fileCertificadoMedico1 &&
      this.state.fileEstudiosLaboratoriales1
    ) {
      this.setState({ disableSgte: false }, () => {});
    }
  }

  /*****************************
   * HANDLE ERROR TYPE OF FILE *
   *****************************/

  handleErrorTypeFile = (element, event) => {
    let typeFile = event.target.files[0]?.type;

    if (
      typeFile !== "application/pdf" &&
      typeFile !== "image/jpeg" &&
      typeFile !== "image/png"
    ) {
      element.current.value = "";
      element.current.dispatchEvent(new Event("change"));
      console.log(element.current);
      console.log(element.current.value);
      Popup.queue(
        this.notifiPopup("Error", "Adjuntar archivo .pdf, .jpg o .png")
      );
      return true;
    }
    return false;
  };

  /*****************************
   * HANDLE ERROR SIZE OF FILE *
   *****************************/

  handleErrorSize = (element, event) => {
    let sizeFile = event.target.files[0].size;

    if (sizeFile > 999999) {
      element.current.value = "";
      element.current.dispatchEvent(new Event("change"));
      Popup.queue(this.notifiPopup("Error", "El archivo debe ser menor a 1mb"));
      return true;
    }
    return false;
  };

    /****************
   * HANDLE FILES *
   ****************/

     openFile = (element) => {
      element.current.click();
    };
  
    handleNewInput = (nameState) => {
      this.setState(
        (prev) => ({
          [`${nameState}`]: [
            ...prev[`${nameState}`],
            {
              nombre: "",
            },
          ],
        }),
        () => {
          bsCustomFileInput.init();
        }
      );
    };
  
    handleDeleteInput = (index, nameState, nameFileState) => {
      const list = [...this.state[`${nameState}`]];
      list.splice(index, 1);
      this.setState((prev) => ({
        [`${nameState}`]: [...list],
        [`${nameFileState}${index+1}`]: undefined,
      }));
    };
  
    handleChangeFile = (event, index, element, nameState) => {
  
      if(this.handleErrorTypeFile(element, event)) return;
      if(this.handleErrorSize(element, event)) return;
  
      this.setState({ [`${nameState}${index+1}`]: event.target?.files[0] }, () =>
      this.handleValidacion()
      );
  
    };

    handleOneFile = (event, element, nameState) => {
      if(this.handleErrorTypeFile(element, event)) return;
      if(this.handleErrorSize(element, event)) return;
  
      this.setState({ [`${nameState}`]: event.target?.files[0] }, () =>
      this.handleValidacion()
      );
    }

    handleDeleteFile = (event, element, nameState) => {
      this.setState({ [`${nameState}`]: undefined }, () => {
        element.current.value = "";
        element.current.dispatchEvent(new Event("change"));
        this.handleValidacion();
      });
    };

  /******************************************
   * CONTINUAR -> CARGA DATOS A SUBSIDIO.JS *
   ******************************************/

  volverSubsidios = () => {
    if (this.props.respuestasData.tipoSubsidio === 5) {
      this.props.goToStep(2);
    }
    if (this.props.respuestasData.tipoSubsidio === 4) {
      this.props.goToStep(4);
    }
  };

  continuar = () => {
    this.props.respuestaPaso3(
      this.state.fileCI1,
      this.state.fileCI2,
      this.state.filePremio1,
      this.state.filePremio2,
      this.state.fileReposoNacimiento,
      this.state.fileAdopcion,
      this.state.fileCertificadoMedico1,
      this.state.fileCertificadoMedico2,
      this.state.fileCertificadoMedico3,
      this.state.fileCertificadoMedico4,
      this.state.fileCertificadoMedico5,
      this.state.fileEstudiosLaboratoriales1,
      this.state.fileEstudiosLaboratoriales2,
      this.state.fileEstudiosLaboratoriales3,
      this.state.fileEstudiosLaboratoriales4,
      this.state.fileEstudiosLaboratoriales5,
      this.state.fileReposoInternacion1,
      this.state.fileReposoInternacion2,
      this.state.fileReposoInternacion3,
    );
    //console.log(this.state)
    this.nextStep.click();
  };

  preventDefault = (e) => {
    e.preventDefault();
  };

  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix steps-doc">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    
                    <span className="title_text">Selección de Cuenta</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                 
                    <span className="title_text">
                      {(this.props.respuestasData.tipoSubsidio === 5 &&
                        "Datos de Reposo") ||
                        (this.props.respuestasData.claseSubsidio === 2 &&
                          "Recién Nacido") ||
                        (this.props.respuestasData.claseSubsidio === 3 &&
                          "Datos Cónyuge")}
                    </span>
                  </div>
                </span>
              </li>

              {this.props.respuestasData.claseSubsidio === 2 && (
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                   
                      <span className="title_text">Datos Cónyuge</span>
                    </div>
                  </span>
                </li>
              )}
              <li role="tab" className="current">
                <span>
                  <div className="title">
                   
                    <span className="title_text current">
                      Adjuntar Documentos
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
             
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                   
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <form id="idFormDocumentos" onSubmit={this.preventDefault}>
          {/* Agregar CI */}
          <div className="row justify-content-md-center">
            <div className="col-md-10">
              <div className="form-group">
                <label className="add-document-label">
                  Cédula de identidad del solicitante *
                </label>
                {this.state.inputCI.map((singleFile, index) => (
                  <div key={index} className="row-document">
                    <div className="row">
                      <div className="col-lg-10 col-md-8">
                      <div className="input-group mb-3">
                        <div className="input-group-prepend">
                          <span
                            className="btn btn-cu-primary"
                            id={`inputArchivoCedula${index + 1}`}
                            onClick={() =>
                              this.openFile(this[`documentCI${index + 1}`])
                            }
                          >
                            Seleccionar
                          </span>
                        </div>
                        <div className="custom-file">
                          <input
                            type="file"
                            ref={
                              (index + 1 === 1 && this.documentCI1) ||
                              (index + 1 === 2 && this.documentCI2)
                            }
                            className="custom-file-input"
                            id={`inputArchivoCedula${index + 1}`}
                            aria-describedby={`inputArchivoCedula${index + 1}`}
                            accept=".pdf, .png, .jpg"
                            onChange={(e) => {
                              this.handleChangeFile(
                                e,
                                index,
                                this[`documentCI${index + 1}`],
                                "fileCI"
                              );
                            }}
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="inputGroupFile01"
                          >
                            Agregar Archivo
                          </label>
                        </div>
                      
                      </div>
                      </div>
                      <div className="col-lg-2 col-md-4">
                     
                         
                            {this.state.inputCI.length === index + 1 &&
                              index + 1 !== 1 && (
                                <button
                                  className="btn btn-cu-secundary btn-document"
                                  onClick={() => {
                                    this.handleDeleteInput(
                                      index,
                                      "inputCI",
                                      "fileCI"
                                    );
                                  }}
                                >
                                  <FontAwesomeIcon icon={faTrashCan} />
                                </button>
                              )}

                            {this.state.inputCI.length - 1 === index &&
                              this.state.inputCI.length < 2 && (
                                <div className={`add-document-btn`}>
                                  <button
                                    className="btn btn-cu-primary btn-document"
                                    onClick={() =>
                                      this.handleNewInput("inputCI")
                                    }
                                  >
                                    <FontAwesomeIcon icon={faPlus} />
                                  </button>
                                </div>
                              )}
                          
                        
                      </div>
                     
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* FIN CI */}
          {/***************************************** * 
                PREMIO POR MATRIMONIO O RECIEN NACIDO 
              ******************************************/}
          {/* Agregar Certificado Matrimonio / Nac */}

          {this.props.respuestasData.tipoSubsidio === 4 && (
            <div className="row justify-content-md-center">
              <div className="col-md-10">
                <div className="form-group">
                  <label className="add-document-label">
                    Certificado de Matrimonio y/o Libreta de Familia otorgado
                    por la Dirección General de Registros del Estado Civil *
                  </label>
                  {this.state.inputPremio.map((singleFile, index) => (
                  <div key={index} className="row-document">
                    <div className="row">
                      <div className="col-lg-10 col-md-8">
                      <div className="input-group mb-3">
                        <div className="input-group-prepend">
                          <span
                            className="btn btn-cu-primary"
                            id={`inputArchivoPremio${index + 1}`}
                            onClick={() =>
                              this.openFile(this[`documentPremio${index + 1}`])
                            }
                          >
                            Seleccionar
                          </span>
                        </div>
                        <div className="custom-file">
                          <input
                            type="file"
                            ref={
                              (index + 1 === 1 && this.documentPremio1) ||
                              (index + 1 === 2 && this.documentPremio2)
                            }
                            className="custom-file-input"
                            id={`inputArchivoPremio${index + 1}`}
                            aria-describedby={`inputArchivoPremio${index + 1}`}
                            accept=".pdf, .png, .jpg"
                            onChange={(e) => {
                              this.handleChangeFile(
                                e,
                                index,
                                this[`documentPremio${index + 1}`],
                                "filePremio"
                              );
                            }}
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="inputGroupFile01"
                          >
                            Agregar Archivo
                          </label>
                        </div>
                       
                      </div>
                      </div>
                      <div className="col-lg-2 col-md-3">
                            {this.state.inputPremio.length === index + 1 &&
                              index + 1 !== 1 && (
                                <button
                                  className="btn btn-cu-secundary btn-document"
                                  onClick={() => {
                                    this.handleDeleteInput(
                                      index,
                                      "inputPremio",
                                      "filePremio"
                                    );
                                  }}
                                >
                                  <FontAwesomeIcon icon={faTrashCan} />
                                </button>
                              )}

                            {this.state.inputPremio.length - 1 === index &&
                              this.state.inputPremio.length < 2 && (
                                <div className={`add-document-btn`}>
                                  <button
                                    className="btn btn-cu-primary btn-document"
                                    onClick={() =>
                                      this.handleNewInput("inputPremio")
                                    }
                                  >
                                    <FontAwesomeIcon icon={faPlus} />
                                  </button>
                                </div>
                              )}
                      </div>
                    
                    </div>
                  </div>
                ))}
                  {/* <div className="row">
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span
                          className="btn btn-cu-primary"
                          id={"inputArchivoPremio"}
                          onClick={() => this.openFile(this[`documentPremio`])}
                        >
                          Seleccionar
                        </span>
                      </div>
                      <div className="custom-file">
                        <input
                          type="file"
                          ref={this.documentPremio}
                          className="custom-file-input"
                          id={`inputArchivoPremio`}
                          aria-describedby={`inputArchivoPremio`}
                          accept=".pdf, .png, .jpg"
                          onChange={(e) => {
                            this.handleOneFile(
                              e,
                              this[`documentPremio`],
                              "filePremio"
                            );
                          }}
                        />
                        <label className="custom-file-label" htmlFor="inputGroupFile01">
                          Agregar Archivo
                        </label>
                      </div>
                      <div className="col-md-2">
                        <div className="doc-flex"></div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          )}
          {/* Fin Archivo Matrimonio / Nac*/}
          {/************************* * 
                 REPOSO POR MATERNIDAD *
              *************************/}
          {/* Agregar REPOSO POR MATERNIDAD / Nacimiento*/}

          {this.props.respuestasData.claseSubsidio === 210 && (
            <div className="row justify-content-md-center">
              <div className="col-md-10">
                <div className="form-group">
                  <label className="add-document-label">
                    Certificado de Nacimiento del Registro Civil o Certificado
                    de Nacido Vivo del Ministerio de Salud o muerte fetal
                  </label>
                  <div className="row">
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span
                          className="btn btn-cu-primary"
                          id={"inputArchivoPremio"}
                          onClick={() =>
                            this.openFile(this[`documentReposoNacimiento`])
                          }
                        >
                          Seleccionar
                        </span>
                      </div>
                      <div className="custom-file">
                        <input
                          type="file"
                          disabled={this.state.fileAdopcion}
                          ref={this.documentReposoNacimiento}
                          className="custom-file-input"
                          id={`inputArchivoReposoNacimiento`}
                          aria-describedby={`inputArchivoReposoNacimientoo`}
                          accept=".pdf, .png, .jpg"
                          onChange={(e) => {
                            this.handleOneFile(
                              e,
                              this[`documentReposoNacimiento`],
                              "fileReposoNacimiento"
                            );
                          }}
                        />
                        <label className="custom-file-label" htmlFor="inputGroupFile01">
                          Agregar Archivo
                        </label>
                      </div>
                      <div className="col-md-2">
                        <div className="doc-flex">
                          {this.state.fileReposoNacimiento && (
                            <div className="input-group-prepend">
                              <button
                                className="btn btn-cu-secundary btn-document"
                                onClick={(e) => {
                                  this.handleDeleteFile(
                                    e,
                                    this[`documentReposoNacimiento`],
                                    "fileReposoNacimiento"
                                  );
                                }}
                              >
                                <FontAwesomeIcon icon={faTrashCan} />
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Fin RESPOSO POR MATERNIDAD / Nacimiento*/}
          {/* Agregar Reposo por REPOSO POR MATERNIDAD / Adopcion*/}

          {this.props.respuestasData.claseSubsidio === 210 && (
            <div className="row justify-content-md-center">
              <div className="col-md-8">
                <div className="form-group">
                  <label className="add-document-label">
                    Sentencia judicial de adopción plena, en caso de adopción
                  </label>
                  <div className="row">
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span
                          className="btn btn-cu-primary"
                          id={"inputArchivoPremio"}
                          onClick={() =>
                            this.openFile(this[`documentReposoNacimiento`])
                          }
                        >
                          Seleccionar
                        </span>
                      </div>
                      <div className="custom-file">
                        <input
                          type="file"
                          disabled={this.state.fileReposoNacimiento}
                          ref={this.documentAdopcion}
                          className="custom-file-input"
                          id={`inputArchivoReposoAdopcion`}
                          aria-describedby={`inputArchivoReposoAdopcion`}
                          accept=".pdf, .png, .jpg"
                          onChange={(e) => {
                            this.handleOneFile(
                              e,
                              this[`documentAdopcion`],
                              "fileAdopcion"
                            );
                          }}
                        />
                        <label className="custom-file-label" htmlFor="inputGroupFile01">
                          Agregar Archivo
                        </label>
                      </div>
                      <div className="col-md-2">
                        <div className="doc-flex">
                          {this.state.fileAdopcion && (
                            <div className="input-group-prepend">
                              <button
                                className="btn btn-cu-secundary btn-document"
                                onClick={(e) => {
                                  this.handleDeleteFile(
                                    e,
                                    this[`documentAdopcion`],
                                    "fileAdopcion"
                                  );
                                }}
                              >
                                <FontAwesomeIcon icon={faTrashCan} />
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Fin Reposo por MATERNIDAD / Adopcion*/}
          {/*********************** * 
                  REPOSO DOMICILIARIO *
              ***********************/}
          {/* Agregar Certificado Reposo Domiciliario */}
          {this.props.respuestasData.claseSubsidio === 7 && (
            <div className="row justify-content-md-center">
              <div className="col-md-10">
                <div className="form-group">
                  <div className="doc-flex">
                    <label className="add-document-label">
                      Adjuntar Certificado de Reposo expedido en formulario de
                      reposo proveido por la Cooperativa *
                      <FontAwesomeIcon className="item-trash" icon={faExclamationCircle} onClick={this.mostrarDatosReposoDomiciliario} /> <b>A tener en cuenta</b>
                      
                    </label>
                  </div>
                  {this.state.inputCertificadoMedico.map(
                    (singleFile, index) => (
                      <div key={index} className="row-document">
                        <div className="row">
                          <div className="col-lg-10 col-md-8">
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span
                                className="btn btn-cu-primary"
                                id={`inputArchivoReposo${index + 1}`}
                                onClick={() =>
                                  this.openFile(
                                    this[`documentReposo${index + 1}`]
                                  )
                                }
                              >
                                Seleccionar
                              </span>
                            </div>
                            <div className="custom-file">
                              <input
                                type="file"
                                ref={
                                  (index + 1 === 1 && this.documentReposo1) ||
                                  (index + 1 === 2 && this.documentReposo2) ||
                                  (index + 1 === 3 && this.documentReposo3) ||
                                  (index + 1 === 4 && this.documentReposo4) ||
                                  (index + 1 === 5 && this.documentReposo5)
                                }
                                className="custom-file-input"
                                id={`inputArchivoReposo${index + 1}`}
                                aria-describedby={`inputArchivoReposo${
                                  index + 1
                                }`}
                                accept=".pdf, .png, .jpg"
                                onChange={(e) => {
                                  this.handleChangeFile(
                                    e,
                                    index,
                                    this[`documentReposo${index + 1}`],
                                    "fileCertificadoMedico"
                                  );
                                }}
                              />
                              <label
                                className="custom-file-label"
                                htmlFor="inputGroupFile01"
                              >
                                Agregar Archivo
                              </label>
                            </div>
                           
                          </div>
                          </div>
                          <div className="col-lg-2 col-md-4">
                                {this.state.inputCertificadoMedico.length ===
                                  index + 1 &&
                                  index + 1 !== 1 && (
                                    <button
                                      className="btn btn-cu-secundary btn-document btn-consulta" style={{marginBottom:"0.5rem"}}
                                      onClick={() => {
                                        this.handleDeleteInput(
                                          index,
                                          "inputCertificadoMedico",
                                          "fileCertificadoMedico"
                                        );
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faTrashCan} />
                                    </button>
                                  )}

                                {this.state.inputCertificadoMedico.length -
                                  1 ===
                                  index &&
                                  this.state.inputCertificadoMedico.length <
                                    5 && (
                                    <div className={`add-document-btn`}>
                                      <button
                                        className="btn btn-cu-primary btn-document"
                                        onClick={() =>
                                          this.handleNewInput(
                                            "inputCertificadoMedico"
                                          )
                                        }
                                      >
                                        <FontAwesomeIcon icon={faPlus} />
                                      </button>
                                    </div>
                                  )}
                          </div>
                          
                         
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          )}
          {/* Fin Reposo */}
          {/* Reposos a partir de siete días*/}

          {this.props.respuestasData.claseSubsidio === 7 &&
            this.props.respuestasData.cantDiasSubsidio >= 7 && (
              <div className="row justify-content-md-center">
                <div className="col-md-10">
                  <div className="form-group">
                    <div className="doc-flex">
                      <label className="add-document-label">
                        Estudios clínicos y laboratoriales u otros documentos
                        que avalen la afección *
                      </label>
                    </div>
                    {this.state.inputEstudiosLaboratoriales.map(
                      (singleFile, index) => (
                        <div key={index} className="row-document">
                          <div className="row">
                            <div className="col-lg-10 col-md-8">
                            <div className="input-group mb-3">
                              <div className="input-group-prepend">
                                <span
                                  className="btn btn-cu-primary"
                                  id={`fileEstudiosLaboratoriales${index + 1}`}
                                  onClick={() =>
                                    this.openFile(
                                      this[`documentEstudiosLab${index + 1}`]
                                    )
                                  }
                                >
                                  Seleccionar
                                </span>
                              </div>
                              <div className="custom-file">
                                <input
                                  type="file"
                                  ref={
                                    (index + 1 === 1 &&
                                      this.documentEstudiosLab1) ||
                                    (index + 1 === 2 &&
                                      this.documentEstudiosLab2) ||
                                    (index + 1 === 3 &&
                                      this.documentEstudiosLab3) ||
                                    (index + 1 === 4 &&
                                      this.documentEstudiosLab4) ||
                                    (index + 1 === 5 &&
                                      this.documentEstudiosLab5)
                                  }
                                  className="custom-file-input"
                                  id={`inputEstudiosLaboratoriales${index + 1}`}
                                  aria-describedby={`inputEstudiosLaboratoriales${
                                    index + 1
                                  }`}
                                  accept=".pdf, .png, .jpg"
                                  onChange={(e) => {
                                    this.handleChangeFile(
                                      e,
                                      index,
                                      this[`documentEstudiosLab${index + 1}`],
                                      "fileEstudiosLaboratoriales"
                                    );
                                  }}
                                />
                                <label
                                  className="custom-file-label"
                                  htmlFor="inputGroupFile01"
                                >
                                  Agregar Archivo
                                </label>
                              </div>
                              
                            </div>
                            </div>
                            <div className="col-lg-2 col-md-4">
                                  {this.state.inputEstudiosLaboratoriales
                                    .length ===
                                    index + 1 &&
                                    index + 1 !== 1 && (
                                      <button
                                        className="btn btn-cu-secundary btn-document btn-consulta" style={{marginBottom:"0.5rem"}}
                                        onClick={() => {
                                          this.handleDeleteInput(
                                            index,
                                            "inputEstudiosLaboratoriales",
                                            "fileEstudiosLaboratoriales"
                                          );
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faTrashCan} />
                                      </button>
                                    )}

                                  {this.state.inputEstudiosLaboratoriales
                                    .length -
                                    1 ===
                                    index &&
                                    this.state.inputEstudiosLaboratoriales
                                      .length < 5 && (
                                      <div className={`add-document-btn`}>
                                        <button
                                          className="btn btn-cu-primary btn-document" 
                                          onClick={() =>
                                            this.handleNewInput(
                                              "inputEstudiosLaboratoriales"
                                            )
                                          }
                                        >
                                          <FontAwesomeIcon icon={faPlus} />
                                        </button>
                                      </div>
                                    )}
                            </div>
                            
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            )}
          {/* Fin Reposos a partir de siete días*/}
          {/********************************* * 
                REPOSO INTERNACION SANATORIAL
              * *********************************/}
          {/* Reposo Internacion Sanatorial*/}

          {this.props.respuestasData.claseSubsidio === 8 && (
            <div className="row justify-content-md-center">
              <div className="col-md-10">
                <div className="form-group">
                  <div className="doc-flex">
                    <label className="add-document-label">
                      Certificado de internación en hoja con membrete del
                      sanatorio u hospital *
                    </label>
                    <FontAwesomeIcon icon={faExclamationCircle} className="item-trash"  onClick={this.mostrarDatosInternacion} /> A tener en cuenta
                  </div>
                  {this.state.inputReposoInternacion.map(
                    (singleFile, index) => (
                      <div key={index} className="row-document">
                        <div className="row">
                          <div className="col-lg-10 col-md-8">
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span
                                className="btn btn-cu-primary"
                                id={`inputReposoInternacion${index + 1}`}
                                onClick={() =>
                                  this.openFile(
                                    this[
                                      `documentReposoInternacion${index + 1}`
                                    ]
                                  )
                                }
                              >
                                Seleccionar
                              </span>
                            </div>
                            <div className="custom-file">
                              <input
                                type="file"
                                ref={
                                  (index + 1 === 1 &&
                                    this.documentReposoInternacion1) ||
                                  (index + 1 === 2 &&
                                    this.documentReposoInternacion2) ||
                                  (index + 1 === 3 &&
                                    this.documentReposoInternacion3)
                                }
                                className="custom-file-input"
                                id={`inputReposoInternacion${index + 1}`}
                                aria-describedby={`inputReposoInternacion${
                                  index + 1
                                }`}
                                accept=".pdf, .png, .jpg"
                                onChange={(e) => {
                                  this.handleChangeFile(
                                    e,
                                    index,
                                    this[
                                      `documentReposoInternacion${index + 1}`
                                    ],
                                    "fileReposoInternacion"
                                  );
                                }}
                              />
                              <label
                                className="custom-file-label"
                                htmlFor="inputGroupFile01"
                              >
                                Agregar Archivo
                              </label>
                            </div>
                          
                          </div>
                          </div>
                          <div className="col-lg-2 col-md-4">
                                {this.state.inputReposoInternacion.length ===
                                  index + 1 &&
                                  index + 1 !== 1 && (
                                    <button
                                      className="btn btn-cu-secundary btn-document btn-consulta" style={{marginBottom:"0.5rem"}}
                                      onClick={() => {
                                        this.handleDeleteInput(
                                          index,
                                          "inputReposoInternacion",
                                          "fileReposoInternacion"
                                        );
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faTrashCan} />
                                    </button>
                                  )}

                                {this.state.inputReposoInternacion.length -
                                  1 ===
                                  index &&
                                  this.state.inputReposoInternacion.length <
                                    3 && (
                                    <div className={`add-document-btn`}>
                                      <button
                                        className="btn btn-cu-primary btn-document"
                                        onClick={() =>
                                          this.handleNewInput(
                                            "inputReposoInternacion"
                                          )
                                        }
                                      >
                                        <FontAwesomeIcon icon={faPlus}  />
                                      </button>
                                    </div>
                                  )}
                          </div>
                        
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          )}
          {/* Fin Reposo Internacion Sanatorial*/}
          <hr />
          <div className="row justify-content-md-center">
            <div className="col-lg-8 col-md-6">
              <label className="input-label-bold-obligatorio float-left">
                (*) Campos Obligatorios
              </label>
            </div>
            <div className="col-lg-2 col-md-3 ">
            <button
                className="btn btn-cu-quintary btn-consulta"
                onClick={this.volverSubsidios}
              >
              <FontAwesomeIcon icon={faArrowLeft} />  Volver
              </button>
            </div>
            <div className="col-lg-2 col-md-3">
            <button
                disabled={this.state.disableSgte}
                className="btn btn-cu-primary"
                onClick={() => {
                  this.continuar();
                }}
              >
                Continuar <FontAwesomeIcon icon={faArrowRight} />
              </button>
              <button
                hidden
                ref={(a) => (this.nextStep = a)}
                className="btn btn-cu-primary"
                onClick={this.props.nextStep}
              ></button>
            </div>
          </div>

          
        </form>
      </div>
    );
  }
}